import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/Postedimages.css';

const Postedimages = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

const [editingImage, setEditingImage] = useState(null); // for modal open
const [editedTitle, setEditedTitle] = useState('');
const [editedDescription, setEditedDescription] = useState('');

  const navigate = useNavigate();

   // Drag and drop state
  const [isDragMode, setIsDragMode] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
   const [dragEnabledId, setDragEnabledId] = useState(null);
   const [highlightedIndex, setHighlightedIndex] = useState(null);

  useEffect(() => {
    const fetchimages = async () => {
      try {
        const res = await axios.get('/api/imagelist');
        setImages(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching members:", error);
        setLoading(false);
      }
    };

    fetchimages();
  }, []);

  const handleDoubleClick = useCallback((e, index) => {
    e.preventDefault();
    setIsDragMode(true);
    setHighlightedIndex(index);
    
    // Auto-disable after 15 seconds
    setTimeout(() => {
      setIsDragMode(false);
    }, 15000);

    setTimeout(() => {
      setHighlightedIndex(false);
    }, 7000);
  }, []);

  const handleDragStart = useCallback((e, index) => {
    if (!isDragMode) {
      e.preventDefault();
      return;
    }
    
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', '');
  }, [isDragMode]);

  const handleDragOver = useCallback((e, index) => {
    if (!isDragMode || draggedIndex === null) return;
    
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    if (index !== draggedIndex) {
      setDragOverIndex(index);
    }
  }, [isDragMode, draggedIndex]);

  const handleDragLeave = useCallback(() => {
    setDragOverIndex(null);
  }, []);

  
  const handleDrop = useCallback(async (e, dropIndex) => {
    e.preventDefault();
    
    if (!isDragMode || draggedIndex === null || draggedIndex === dropIndex) {
      setDragOverIndex(null);
      return;
    }

    // Reorder the videos array
    const newImages = [...images];
   
    const draggedImage = newImages[draggedIndex];
    
    // Remove from old position
    newImages.splice(draggedIndex, 1);
    
    // Insert at new position
    newImages.splice(dropIndex, 0, draggedImage);
    
    // Update state
    setImages(newImages);
     console.log('newimg', newImages);
    setDraggedIndex(null);
    setDragOverIndex(null);
    setIsDragMode(false);

    // Send new order to backend
    try {
      //const reorderedVideos = newVideos.map(video => video._id);
      //console.log('reordered', reorderedVideos);
       const resp = await axios.put('/api/imagesreorder', newImages);
      // await fetch('/videosreorder', {
      //   method: 'PUT',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Bearer ${localStorage.getItem('token')}`
      //   },
      //   body: JSON.stringify({ videos: reorderedVideos })
      // });

      console.log('Images order updated successfully');
      console.log(resp.message);
    } catch (error) {
      console.error('Error updating Images order:', error);
      // Optionally show error message to user
    }
  }, [isDragMode, draggedIndex, images]);

  const handleDragEnd = useCallback(() => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  }, []);


   const getCardStyle = (index) => {
    const baseStyle = { ...styles.blogPost };
    
    if (isDragMode) {
      baseStyle.cursor = 'grab';
    }
    
    if (draggedIndex === index) {
      baseStyle.opacity = 0.6;
      baseStyle.cursor = 'grabbing';
    }
    
    if (dragOverIndex === index && draggedIndex !== index) {
      baseStyle.borderColor = '#007bff';
      baseStyle.backgroundColor = '#f8f9ff';
    }

    if (highlightedIndex === index) {
     baseStyle.border = '4px solid #007bff';
    baseStyle.borderRadius = '8px';
    //baseStyle.outline = '2px solid #0056b3';
    baseStyle.outlineOffset = '2px';
    baseStyle.backgroundColor = '#ffffff';
    baseStyle.position = 'relative';
    baseStyle.zIndex = '10';
    baseStyle.transition = 'all 0.2s ease-in-out';
  }
    
    return baseStyle;
  };


  const handleEditImage = (id) => {
  const imageToEdit = images.find((img) => img._id === id);
  setEditingImage(imageToEdit);
  setEditedTitle(imageToEdit.title);
  setEditedDescription(imageToEdit.description);
};

const handleSaveEdit = async () => {
  if (!editingImage) return;

  try {
    const response = await fetch(`/api/images/${editingImage._id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: editedTitle,
        description: editedDescription,
      }),
    });

    const data = await response.json();
    if (response.ok) {
      // Update frontend instantly
      setImages((prevImages) =>
        prevImages.map((img) =>
          img._id === editingImage._id ? { ...img, title: editedTitle, description: editedDescription } : img
        )
      );
      setEditingImage(null);
    } else {
      alert(data.message || 'Failed to update image');
    }
  } catch (error) {
    console.error('Error updating image:', error);
    alert('Error updating image');
  }
};


  // Handle individual video delete
    const handleDeleteImage = async (imageId) => {
      
      const confirmed = window.confirm(`Are you sure you want to delete?`);
      if (!confirmed) return;
      try {
      const res = await axios.delete(`/api/deleteimages/${imageId}`);
      console.log('Deleted image:', res.data);
      setImages(prev => prev.filter(image => image._id !== imageId));
       } catch (error) {
      console.error('Error deleting image:', error.response?.data?.message || error.message);
      alert(`Failed to delete image: ${error.response?.data?.message || error.message}`);
    }
  
    };

  if (loading) return <CircularProgress />;

  return (
      <Box className="ptimgcontainer">
      <div className='ptimgheader'>
        <h1 className='ptimgpageTitle'>Image Gallery</h1>
        <button className='ptimgaddButton' onClick={() => navigate('/dashboard/images/addimage')}>
          <svg className='ptimgicon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Image
        </button>
      </div>

      <div className='ptimginstructionBanner'>
        <svg className='ptimginfoIcon' fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
        <span>Double-click on any card to enable drag & drop mode for 15 seconds</span>
      </div>

      {images.length === 0 ? (
        <div className='ptimgemptyState'>
          <svg className='ptimgemptyIcon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <h3 className='ptimgemptyTitle'>No images yet</h3>
          <p className='ptimgemptyText'>Start by adding your first image to the gallery</p>
        </div>
      ) : (
        <div className='ptimggalleryGrid'>
          {images.map((img, index) => (
            <div 
              key={img._id} 
              style={getCardStyle(index)}
              draggable={isDragMode}
              onDoubleClick={(e) => handleDoubleClick(e, index)}
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, index)}
              onDragEnd={handleDragEnd}
            >
              <div className='ptimgimageWrapper'>
                <img
                  src={img.imageUrl}
                  alt={img.title}
                  //style={styles.galleryImage}
                  className='ptimggalleryImage'
                />
              </div>
               <div className="ptimgcardContent">
            <div className="ptimgcardHeader">
              <h3 className="ptimgcardTitle">{img.title}</h3>
              <div className="ptimgactionButtons">
                    <button 
                      //style={styles.editBtn}
                      onClick={(e) => handleEditImage(img._id)}
                      title="Edit Image"
                      className='ptimgeditBtn'
                    >
                      <svg className='ptimgbtnIcon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button 
                      //style={styles.}
                      onClick={(e) => handleDeleteImage(img._id)}
                      title="Delete Image"
                      className='ptimgdeleteBtn'
                    >
                      <svg className='ptimgbtnIcon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
                <p className='ptimgcardDescription'>{img.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {editingImage && (
  <div className='ptimgmodalOverlay'>
    <div className='ptimgmodalContent'>
      <h2>Edit Image Details</h2>
      <img
        src={editingImage.imageUrl}
        alt={editingImage.title}
        style={{ width: '100%', borderRadius: '10px', marginBottom: '1rem' }}
      />
      <div>
        <label className='ptimglabel'>Title</label>
        <input
          type="text"
          value={editedTitle}
          onChange={(e) => setEditedTitle(e.target.value)}
          //style={styles.input}
          className='ptimginput'
        />
      </div>
      <div>
        <label className='ptimglabel'>Description</label>
        <textarea
          value={editedDescription}
          onChange={(e) => setEditedDescription(e.target.value)}
          //style={styles.textarea}
          className='ptimgtextarea'
        />
      </div>
      <div className='ptimgmodalActions'>
        <button onClick={handleSaveEdit} className='ptimgsaveBtn'>Save</button>
        <button className='ptimgcancelBtn' onClick={() => setEditingImage(null)}>Cancel</button>
      </div>
    </div>
  </div>
)}

    </Box>
    // <Box p={3}>
    //     <h1 style={styles.pageTitle}>Image Gallery</h1>
    //       <div style={styles.contentCard}>
    //         <div style={styles.cardHeader}>
    //           <h3 style={styles.cardTitle}>Recent images</h3>
    //           <button style={styles.imageButton} onClick={() => navigate('/dashboard/images/addimage')}>
    //             Add Image
    //           </button>
    //         </div>
    //         {images.map((img, index) => (
    //                 <div key={img._id} 
                    
    //                 style={getCardStyle(index)}
    //                  draggable={isDragMode}
    //           onDoubleClick={(e) => handleDoubleClick(e, index)}
    //           onDragStart={(e) => handleDragStart(e, index)}
    //           onDragOver={(e) => handleDragOver(e, index)}
    //           onDragLeave={handleDragLeave}
    //           onDrop={(e) => handleDrop(e, index)}
    //           onDragEnd={handleDragEnd}
    //                 >
              
              
                
           
    //             <h4 style={styles.blogTitle}>{img.title}</h4>
              
    //             <img
    //                       src={img.imageUrl}  
    //                       alt="Uploaded"
    //                       style={{ width: '100%', maxWidth: '400px', borderRadius: '8px', marginTop:'10px' }}
    //              />
    //             <p style={styles.blogMeta}>Description: {img.description}</p>
               
    //           </div>
    //         ))}
    //       </div>
    // </Box>
  )};

  const styles = {
//    container: {
//     minHeight: '100vh',
    
//     padding: '2rem',
//   },
//   header: {
//     maxWidth: '1400px',
//     margin: '0 auto 2rem',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     gap: '1rem',
//   },
//   pageTitle: {
//     fontSize: '2.5rem',
//     color: 'black',
//     fontWeight: '700',
//     margin: 0,
//     textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
//   },
//   addButton: {
//     background: 'white',
//     color: '#667eea',
//     border: 'none',
//     padding: '0.75rem 1.5rem',
//     borderRadius: '50px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
//   },
//   icon: {
//     width: '20px',
//     height: '20px',
//   },
//   instructionBanner: {
//     maxWidth: '1400px',
//     margin: '0 auto 2rem',
//     background: 'rgba(255, 255, 255, 0.95)',
//     padding: '1rem 1.5rem',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.75rem',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     color: '#667eea',
//     fontSize: '0.95rem',
//     fontWeight: '500',
//   },
//   infoIcon: {
//     width: '24px',
//     height: '24px',
//     flexShrink: 0,
//   },
//   galleryGrid: {
//     maxWidth: '1400px',
//     margin: '0 auto',
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
//     gap: '2rem',
//   },
//   galleryCard: {
//     background: 'white',
//     borderRadius: '16px',
//     overflow: 'hidden',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//     transition: 'all 0.3s ease',
//     border: '2px solid transparent',
//     position: 'relative',
//   },
//   imageWrapper: {
//     position: 'relative',
//     width: '100%',
//     height: '250px',
//     overflow: 'hidden',
//     background: '#f3f4f6',
//   },
//   galleryImage: {
//     width: '100%',
//     height: '100%',
//     borderRadius:'10px',
//     objectFit: 'cover',
//     transition: 'transform 0.3s ease',
//   },
//   cardContent: {
//     padding: '1.5rem',
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     marginBottom: '0.75rem',
//     gap: '1rem',
//   },
//   cardTitle: {
//     fontSize: '1.5rem',
//     color: '#1f2937',
//     fontWeight: '600',
//     margin: 0,
//     flex: 1,
//   },
//   actionButtons: {
//     display: 'flex',
//     gap: '0.5rem',
//     flexShrink: 0,
//   },
//   editBtn: {
//     width: '36px',
//     height: '36px',
//     background: '#3b82f6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.2s ease',
//   },
//   deleteBtn: {
//     width: '36px',
//     height: '36px',
//     background: '#ef4444',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.2s ease',
//   },
//   btnIcon: {
//     width: '18px',
//     height: '18px',
//   },
//   cardDescription: {
//     color: '#6b7280',
//     lineHeight: '1.6',
//     fontSize: '0.95rem',
//     margin: 0,
//   },
//   emptyState: {
//     maxWidth: '1400px',
//     margin: '4rem auto',
//     textAlign: 'center',
//     background: 'white',
//     padding: '4rem 2rem',
//     borderRadius: '16px',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//   },
//   emptyIcon: {
//     width: '80px',
//     height: '80px',
//     margin: '0 auto 1.5rem',
//     color: '#9ca3af',
//   },
//   emptyTitle: {
//     fontSize: '1.5rem',
//     color: '#1f2937',
//     marginBottom: '0.5rem',
//   },
//   emptyText: {
//     color: '#6b7280',
//     fontSize: '1rem',
//   },
//   modalOverlay: {
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   margin: '0 auto',
//   // backgroundColor: 'rgba(0,0,0,0.6)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   zIndex: 1000,
// },
// modalContent: {
//   backgroundColor: 'white',
//   borderRadius: '12px',
//   padding: '2rem',
//   width: '90%',
//   maxHeight: '80vh', // prevents it from going full height
//   overflowY: 'auto', // scroll only inside modal if needed
//   maxWidth: '500px',
//   boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
// },
// label: {
//   display: 'block',
//   marginBottom: '0.5rem',
//   fontWeight: '600',
//   color: '#374151',
// },
// input: {
//   width: '100%',
//   padding: '0.5rem',
//   marginBottom: '1rem',
//   borderRadius: '8px',
//   border: '1px solid #d1d5db',
// },
// textarea: {
//   width: '100%',
//   padding: '0.5rem',
//   minHeight: '80px',
//   marginBottom: '1rem',
//   borderRadius: '8px',
//   border: '1px solid #d1d5db',
// },
// modalActions: {
//   display: 'flex',
//   justifyContent: 'flex-end',
//   gap: '1rem',
// },
// saveBtn: {
//   backgroundColor: '#3b82f6',
//   color: 'white',
//   border: 'none',
//   padding: '0.5rem 1rem',
//   borderRadius: '8px',
//   cursor: 'pointer',
//   fontWeight: '600',
// },
// cancelBtn: {
//   backgroundColor: '#e5e7eb',
//   color: '#374151',
//   border: 'none',
//   padding: '0.5rem 1rem',
//   borderRadius: '8px',
//   cursor: 'pointer',
//   fontWeight: '600',
// },
blogPost: {
    //borderLeft: '4px solid #3b82f6',
    //paddingLeft: '16px',
    //paddingTop: '8px',
    paddingBottom: '8px',
    marginBottom: '12px'
  }
};
// const styles = {

// contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
 
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   imageButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     top: '25%',
//     right: '10%',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//    addButton: {
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     border: 'none',
//     padding: '12px 24px',
//     borderRadius: '8px',
//     fontSize: '16px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease'
//   },
//    blogPost: {
//     borderLeft: '4px solid #3b82f6',
//     paddingLeft: '16px',
//     paddingTop: '8px',
//     paddingBottom: '8px',
//     marginBottom: '12px'
//   },
//   blogTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   blogMeta: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: 0
//   },
//   cardHeader: {
//      display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
 
//    deleteIconButton: {
//     backgroundColor: 'rgba(239, 68, 68, 0.9)',
//     border: 'none',
//     borderRadius: '6px',
//     padding: '6px 8px',
//     cursor: 'pointer',
  
//     fontSize: '14px',
//     transition: 'all 0.2s ease'
//   },
// }


export default Postedimages;